import {
  alias, params, string, extend, arrayOf, shape, bool, number, customType
} from '@thd-nucleus/data-sources';
import { ProductPod } from '@thd-olt-component-react/product-pod';
import { wrappedProduct } from './core/RecommendationsProductPodCarousel';
import { wrappedProduct1 } from './core/ProductPodV7Carousel';

const productModel = extend({}, {
  itemId: string(),
  dataSource: string(),
}, ProductPod.dataModel.product);

export const dataModel = extend({
  recsProducts:
    alias('products').params({
      itemIds: arrayOf(string().isRequired()).isRequired(),
      dataSource: string()
    }).arrayOf(productModel),
});
const queryParams = {
  apiName: string().isRequired(),
  appId: string(),
  key: string().isRequired(),
  storeId: string(),
};

const metadata = {
  apiName: string(),
  title: string(),
  modelName: string(),
  fallbackModelName: string(),
  type: string(),
  version: string(),
};

const collectionsMetaData = {
  collectionTitle1: string(),
  collectionTitle2: string(),
  collectionPlpUrl: string(),
  collectionImageUrl: string(),
  collectionDesc: string(),
  collectionName: string()
};

export const dynamicRecsDataModel = {
  recs: params({
    anchorId: string().isRequired(),
    apiName: string().isRequired(),
    loyaltyMembershipInput: customType('LoyaltyMembershipInput').shape({
      svocID: string(),
      programTiers: arrayOf(shape({
        tier: string(),
        program: string()
      }))
    }),
    storeId: string(),
    serviceType: string(),
    appId: string(),
    key: string(),
    maxResults: string(),
  }).shape({
    metadata: shape({
      apiName: string(),
      title: string(),
      version: string(),
      modelName: string(),
      fallbackModelName: string(),
      type: string(),
      ...collectionsMetaData,
    }),
    categories: arrayOf(shape({
      category: string(),
      itemIds: arrayOf(string())
    })),
    products: arrayOf(wrappedProduct1)
  })
};

export const rvDataModel = {
  uds: params({
    userId: string().isRequired(),
    ...queryParams,
    unique: bool(),
    // showPrice: bool()
  }).shape({
    metadata: shape({
      ...metadata
    }),
    products: arrayOf(wrappedProduct1)
  })
};

const trendingNearYouWrappedImage = {
  url: string(),
  type: string(),
  subType: string(),
  sizes: arrayOf(string()),
  __typename: string()
};

const trendingNearYouWrappedProduct = {
  product: shape({
    categoryUrl: string(),
    categoryName: string(),
    identifiers: shape({
      canonicalUrl: string()
    }),
    itemId: string(),
    media: shape({
      images: arrayOf(
        trendingNearYouWrappedImage
      ),
      __typename: string()
    })
  })
};

export const trendingNearYouDataModel = {
  uds: params({
    apiName: string().isRequired(),
    appId: string().isRequired(),
    key: string().isRequired(),
    storeId: string().isRequired(),
  }).shape({
    metadata: shape({
      ...metadata
    }),
    products: arrayOf(trendingNearYouWrappedProduct)
  })
};

export const todaysRecommendationsDataModel = {
  uds: params({
    ...queryParams,
    columnFamily: string(),
    schema: string(),
    tableName: string(),
    userId: string().isRequired(),
  }).shape({
    metadata: shape({
      ...metadata
    }),
    products: arrayOf(wrappedProduct)
  })
};

export const reorderDataModel = {
  uds: params({
    ...queryParams,
    cType: string(),
    exItems: string(),
    filter: string(),
    maxProducts: number(),
    model: string(),
    showPrice: bool(),
    tableName: string(),
    userId: string().isRequired()
  }).shape({
    metadata: shape({
      ...metadata
    }),
    products: arrayOf(wrappedProduct)
  }),
};

export const priceDropDataModel = {
  uds: params({
    ...queryParams,
    userId: string().isRequired()
  }).shape({
    metadata: shape({
      ...metadata
    }),
    products: arrayOf(wrappedProduct)
  }),
};

const wrappedArticle = {
  guid: string(),
  title: string(),
  articleType: string(),
  imageUrl: string(),
  guideUrl: string(),
  difficulty: string(),
  youtubeUrl: string(),
};

export const articleGuidesDataModel = {
  uds: params({
    apiName: string().isRequired(),
    key: string().isRequired(),
    userId: string(),
  }).shape({
    metadata: shape({
      apiName: string(),
    }),
    articles: arrayOf(wrappedArticle),
  }),
};

export const supplementalRecsdataModel = {
  recs: params({
    anchorId: string().isRequired(),
    apiName: string().isRequired(),
    appId: string(),
    key: string(),
    storeId: string(),
  }).shape({
    metadata: shape({
      ...metadata
    }),
    products: arrayOf(wrappedProduct1)
  })
};
